/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Dynamically calculate years of experience
const yearsOfExperience = new Date().getFullYear() - 2016;

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 500 // Set animation duration as per your animation
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  resumeLink:
    "https://drive.google.com/file/d/1zNs-FXeb2BAOf764JVUOeZGGXO8fNrXL/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/abdel-majid",
  linkedin: "https://www.linkedin.com/in/abdalmajide/",
  gmail: "abd.almajide@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Skills",
  subTitle: `Here are some of my skills on which I have been working on for the past ${yearsOfExperience} years.`,
  skills: [],

  /* Make Sure to include correct dev icon Classname to view your icon https://devicon.dev */

  softwareSkills: [
    {skillName: "Java", devIconClassName: "fab fa-java", type: "backend"},
    {
      skillName: "Spring",
      devIconClassName: "devicon-spring-original",
      type: "backend"
    },
    {
      skillName: "RabbitMQ",
      devIconClassName: "devicon-rabbitmq-original",
      type: "backend"
    },
    {
      skillName: "ElasticSearch",
      devIconClassName: "devicon-elasticsearch-plain",
      type: "backend"
    },
    {
      skillName: "Angular",
      devIconClassName: "devicon-angular-plain",
      type: "frontend"
    },
    {
      skillName: "Angular Material",
      devIconClassName: "devicon-angularmaterial-plain",
      type: "frontend"
    },
    {
      skillName: "Android",
      devIconClassName: "fab fa-android",
      type: "frontend"
    },
    {
      skillName: "Flutter",
      devIconClassName: "devicon-flutter-plain",
      type: "frontend"
    },
    {skillName: "HTML", devIconClassName: "fab fa-html5", type: "frontend"},
    {
      skillName: "CSS",
      devIconClassName: "fab fa-css3-alt",
      type: "frontend"
    },
    {
      skillName: "Bootstrap",
      devIconClassName: "fab fa-bootstrap",
      type: "frontend"
    },
    {
      skillName: "Jenkins",
      devIconClassName: "fab fa-jenkins",
      type: "devops"
    },
    {skillName: "Git", devIconClassName: "fab fa-git", type: "devops"},
    {
      skillName: "GitHub",
      devIconClassName: "fab fa-github",
      type: "devops"
    },
    {
      skillName: "Hibernate",
      devIconClassName: "devicon-hibernate-plain",
      type: "backend"
    },
    {
      skillName: "Insomnia",
      devIconClassName: "devicon-insomnia-plain",
      type: "others"
    },
    {
      skillName: "SQL Server",
      devIconClassName: "devicon-microsoftsqlserver-plain",
      type: "backend"
    },
    {
      skillName: "MySQL",
      devIconClassName: "devicon-mysql-original",
      type: "backend"
    },
    {
      skillName: "GitLab",
      devIconClassName: "fab fa-gitlab",
      type: "devops"
    },
    {
      skillName: "Postman",
      devIconClassName: "devicon-postman-plain",
      type: "others"
    },
    {
      skillName: "PostgreSQL",
      devIconClassName: "devicon-postgresql-plain",
      type: "backend"
    },
    {
      skillName: "Maven",
      devIconClassName: "devicon-maven-plain",
      type: "backend"
    },
    {
      skillName: "TailwindCSS",
      devIconClassName: "devicon-tailwindcss-original",
      type: "frontend"
    },
    {
      skillName: "TypeScript",
      devIconClassName: "devicon-typescript-plain",
      type: "frontend"
    },
    {
      skillName: "VSCode",
      devIconClassName: "devicon-vscode-plain",
      type: "others"
    },
    {
      skillName: "Kibana",
      devIconClassName: "devicon-kibana-plain",
      type: "others"
    },
    {
      skillName: "JavaScript",
      devIconClassName: "fab fa-js",
      type: "frontend"
    },
    {skillName: "NPM", devIconClassName: "fab fa-npm", type: "frontend"},
    {
      skillName: "MongoDB",
      devIconClassName: "devicon-mongodb-plain",
      type: "backend"
    },
    {
      skillName: "Azure",
      devIconClassName: "devicon-azure-plain",
      type: "devops"
    },
    {skillName: "AWS", devIconClassName: "fab fa-aws", type: "devops"},
    {
      skillName: "Docker",
      devIconClassName: "fab fa-docker",
      type: "devops"
    },
    {
      skillName: "IntelliJ",
      devIconClassName: "devicon-intellij-plain",
      type: "others"
    },
    {
      skillName: "Android Studio",
      devIconClassName: "devicon-androidstudio-plain",
      type: "others"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      company: "Total energies",
      companylogo: require("./assets/images/totalenergiesLogo.png")
    },
    {
      company: "Acensi",
      companylogo: require("./assets/images/asenciLogo.jpeg")
    },
    {
      company: "Banque populaire",
      companylogo: require("./assets/images/banquepopulaireLogo.png")
    }
  ]
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certifications 🏆 "),
  subtitle: "A Look at the Certifications That Mark My Growth",

  achievementsCards: [
    {
      title: "Oracle Certified Professional, Java SE 11 Programmer",
      type: "WEB",
      image: require("./assets/images/java11Badge.png"),
      imageAlt: "Java 11 Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1YLJyxkBF9-HAyvetwCsAFVREGgoIpm6q/view?usp=drive_link"
        }
      ]
    },
    {
      title: "Oracle Certified Associate, Java SE 8 Programmer",
      type: "WEB",
      image: require("./assets/images/java8Badge.png"),
      imageAlt: "Java 8 Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1jvxoNZ2Wl7NBmfSZwIVGj9yYl9o2wRzE/view?usp=drive_link"
        }
      ]
    },
    {
      title: "AWS Cloud Quest: Cloud Practitioner",
      type: "Cloud",
      image: require("./assets/images/awsLogo.png"),
      imageAlt: "AWS Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/7fbe33e9-5dde-4aa4-a992-8b944be7d241"
        }
      ]
    },
    {
      title: "Generative AI Fundamentals",
      type: "Others",
      image: require("./assets/images/generativeAiLogo.png"),
      imageAlt: "AWS Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://credentials.databricks.com/b47e96e5-95c5-43e7-b916-242ec4c3b1ae#acc.1F9VuOjN"
        }
      ]
    },
    {
      title: "GitLab Certified Associate",
      type: "Devops",
      image: require("./assets/images/gitlabAssocaiteLogo.png"),
      imageAlt: "GitLab Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/8e51bd5f-e047-4a8f-b07a-625660dec32e/public_url"
        }
      ]
    },
      {
      title: "Foundations of Git ",
      type: "Devops",
      image: require("./assets/images/gitLogo.png"),
      imageAlt: "Git Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://learn.gitkraken.com/certificates/i6fwqgdhaz"
        }
      ]
    },
    {
      title: "Scrum Master",
      type: "Others",
      image: require("./assets/images/scrummasterLogo.png"),
      imageAlt: "Scrum Master Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1cM55DrGjco4eoxE_wYzc0T1ogFZxZdwL/view?usp=drive_link"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  number: "+33 7 53 75 72 49",
  email_address: "abd.almajide@gmail.com"
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  workExperiences,
  achievementSection,
  contactInfo,
  isHireable,
  openSource,
  resumeSection,
  yearsOfExperience
};
